import { Offering } from '@arrived/models';

import { calculateRemainingShares } from '../calculateRemainingShares';

export const getAvailableOfferingFunds = (offering: Offering): number => {
  const remainingShares = calculateRemainingShares(offering);

  return remainingShares === 0 ? remainingShares : remainingShares * offering.sharePrice;
};
